<template>
    <div class="components_table_html">
        <!-- 表格 -->
        <div class="components_table_in">
            <a-table
                :show-overflow-tooltip="true"
                tableLayout="fixed"
                rowKey="id"
                :dataSource="toTableData" 
                :scroll="{scrollToFirstRowOnChange:false,x: toTableX? '100%' :false, y: 'calc(100vh - '+toTableY+'px)'}" 
                :columns="toColumns" 
                :row-selection="rowSelection"
                :custom-row="customRow"
                :bordered="toBordered" 
                :size="toSize" 
                :pagination="false" 
                :loading="toTableLoading"
                @change="handleTableChange"
                :expandIconAsCell="false"
                :expandIconColumnIndex="1"
            >
                <!-- 表格内的表格数据 toInTable为判断是否开始这个功能-->
                <template v-if="toInTable" #expandedRowRender="{ record }">
                    <a-table style="margin-left:25px;" :size="toSize" v-if="toInTableName==='delivery'" :data-source="record.inList" :columns="deliveryProductColumns" :pagination="false" rowKey="id" >
                                <template #long="{ text }">
                                    <div class="long">
                                        <a-tooltip :title="text">
                                            {{text}}
                                        </a-tooltip>
                                    </div>
                                </template>
                                <template #productLong="{ text }">
                                    <div class="long">{{text}}
                                        <!-- <a-tooltip :title="data.productList.find(item => {return item.id == text}).name">
                                            {{data.productList.find(item => {return item.id == text}).name}}
                                        </a-tooltip> -->
                                    </div>
                                </template>
                                <template #userLong="{ text }">
                                    <div class="long">{{text}}
                                        <!-- <a-tooltip :title="data.userList.find(item => {return item.id == text}).realName">
                                            {{data.userList.find(item => {return item.id == text}).realName}}
                                        </a-tooltip> -->
                                    </div>
                                </template>
                    </a-table>
                    <a-table style="margin-left:25px;" v-if="toInTableName==='quality'" :size="toSize" :data-source="record.inList" :columns="qualityProductColumns" :pagination="false" rowKey="id" >
                        <template #long="{ text }">
                            <div class="long">
                                <a-tooltip :title="text">
                                    {{text}}
                                </a-tooltip>
                            </div>
                        </template>
                    </a-table>
                </template>
                <template #img="{ record }">
                    <a-image
                        :width="32"
                        :height="32"
                        :src="record.salt"
                        fallback="data:image/png;base64,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"
                    />
                </template>
                <template #excel="{ record }">
                    <div class="imgList" >
                        <a-image
                            :width="32"
                            :height="32"
                            :src="'https://www.yuxisuye.cn/appyuxi/excel.png'"
                            fallback="data:image/png;base64,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"
                        />
                    </div>
                    <div class="excelName" @click="toRAR(record.excelName ,record.excelUrl)">{{ record.excelName }}</div>
                </template>
                <template #bigfile="{ record }">
                    <div class="imgList" v-if="record.bigfileUrl">
                        <a-image
                            :width="32"
                            :height="32"
                            :src="'https://www.yuxisuye.cn/appyuxi/rar.png'"
                            fallback="data:image/png;base64,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"
                        />
                    </div>
                    <div class="excelName" v-if="record.bigfileUrl" @click="toRAR(record.bigfileName,record.bigfileUrl)">{{ record.bigfileName }}</div>
                    <div class="excelName" v-if="!record.bigfileUrl">无</div>
                </template>
                <template #imgList="{ record }">
                    <div v-if="record.imageList" class="imgList" v-for="(item,index) in record.imageList.split('丨')" :key="index+1">
                        <a-image
                            :width="32"
                            :height="32"
                            :src="item"
                            fallback="data:image/png;base64,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"
                        />
                    </div>
                </template>
                <template #long="{ text }">
                    <div class="long">
                        <a-tooltip :title="text">
                            {{text}}
                        </a-tooltip>
                    </div>
                </template>
                <template #ioWarehouseNum="{ text,record }">
                    <div v-if="record.type<=2" class="ioWarehouseNumInt">
                        +{{text}}
                    </div>
                    <div v-if="record.type>2" class="ioWarehouseNumOut">
                        -{{text}}
                    </div>
                </template>
                <template #rawMaterialIoWarehouseNum="{ text,record }">
                    <div v-if="record.type==1" class="ioWarehouseNumInt">
                        +{{text}}
                    </div>
                    <div v-if="record.type==2" class="ioWarehouseNumOut">
                        -{{text}}
                    </div>
                </template>
                <template #ioWarehouseSee="{ text,record }">
                    <a-button type="link" @click="ioWarehouseSee(record.productId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                                {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #orderDetails="{ text,record }">
                    <a-button type="link" @click="tableOrderDetails(record.orderId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                                {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #productDetails="{ text,record }">
                    <a-button type="link" @click="tableProductDetails(record.productId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                                {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #reviewDetails="{ text,record }">
                    <a-button type="link" @click="tableUserDetails(record.reviewId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                            {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #takeDetails="{ text,record }">
                    <a-button type="link" @click="tableTakeDetails(record.takeDeliveryId)" class="take_btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                            {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #qualityDetails="{ text,record }">
                    <a-button type="link" @click="tableQualityDetails(record.qualityId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                            {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #consignorDetails="{ text,record }">
                    <a-button type="link" @click="tableUserDetails(record.consignorId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                            {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #producerDetails="{ text,record }">
                    <a-button type="link" @click="tableUserDetails(record.producerId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                                {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #deliveryDetails="{ text,record }">
                    <a-button type="link" @click="tableDeliveryDetails(record.deliveryId)" class="btn" v-if="typeof(text)!='undefined' && text!='' && text!=null">
                        <div class="long">
                            <a-tooltip :title="text">
                                {{text}}
                            </a-tooltip>
                        </div>
                    </a-button>
                </template>
                <template #isDeleted="{ record }">
                    <div v-if="record.isDeleted==0">
                        否
                    </div>
                    <div v-if="record.isDeleted==1" class="ioWarehouseNumInt">
                        是
                    </div>
                </template>
            </a-table>
        </div>
        <!-- 翻页控件 -->
        <div class="components_table_page">
            <a-pagination 
                :page-size-options="dataPageSizeOptions" 
                :defaultPageSize="dataDefaultPageSize" 
                :style="toPageStyle" 
                :total="toDataTotal" 
                :show-total="total => `共 ${total} 条`" 
                :current="dataCurrent"
                :pageSize="dataPageSize"
                @change="pageChange"
                @showSizeChange="onShowSizeChange"
                show-size-changer 
                show-quick-jumper 
                >
                    <template #buildOptionText="props">
                        <span>{{ props.value }} 条/页</span>
                    </template>
            </a-pagination>
        </div>
    </div>
    
</template>
<script>
import { reactive,ref,computed } from 'vue';
export default {
    name: "Table",
    props: {
        //默认提取的id
        toRowKey:{
            type: String,
            default: "id"
        },
        //表格数据
        toTableData: {
            type: Array,
            default: {}
        },
        //表格滚动条高度
        toTableY: {
            type: Number,
            default: 0
        },
        //表格滚动条宽度
        toTableX: {
            type: Boolean,
            default: true
        },
        //表格head数据
        toColumns: {
            type: Array,
            default: []
        },
        //表格是否有表格线
        toBordered: {
            type: Boolean,
            default: true
        },
        //表格字体行距大小
        toSize:{
            type: String,
            default: "middle"
        },
        //是否开启表格加载
        toTableLoading:{
            type: Boolean,
            default: false
        },
        //翻页控件 样式（设置浮动方向）
        toPageStyle:{
            type: String,
            default: "float: right;"
        },
        //共几条数据
        toDataTotal: {
            type: Number,
            default: 0
        },
        //是否开启表格内的表格
        toInTable:{
            type: Boolean,
            default: false
        },
        //表格内的表格的内容名称
        toInTableName:{
            type: String,
            default: ""
        },
        //一页几条
        toPageSize: {
            type: Number,
            default: 15
        },
    },
    setup(props, context){
        const dataDefaultPageSize = ref(props.toPageSize);//默认每页显示的条数
        const dataPageSizeOptions = ref([props.toPageSize+'',  '30', '50']);//可以选择每页显示的条数
        const dataCurrent = ref(1);//当前第几页
        const dataPageSize = ref(props.toPageSize);//每页显示的条数
        const sortedInfo = ref();//排序样式是否开启
        const cData = reactive({
            queryData:{},
            selectedRowKeys: [],
            sort:"",
            desc:"",
        });
        //发货产品单表格列表
        const deliveryProductColumns = computed(() => {
            return [
                {
                    title: '出库单',
                    dataIndex: 'ioId',
                    key: 'io_id',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品名称',
                    dataIndex: 'productName',
                    key: 'product_name',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '发货数量',
                    dataIndex: 'productNum',
                    key: 'product_num',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品型号',
                    dataIndex: 'productModel',
                    key: 'product_model',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '尺寸',
                    dataIndex: 'productSize',
                    key: 'product_size',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品重量(kg)',
                    dataIndex: 'productWeight',
                    key: 'product_weight',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品颜色',
                    dataIndex: 'productColor',
                    key: 'product_color',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '计量单位',
                    dataIndex: 'productUnit',
                    key: 'product_unit',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                
                {
                    title: '备注',
                    dataIndex: 'deliveryExplain',
                    key: 'delivery_explain',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
            ]
        })

        //入库质检制单的产品表格列属性
        const qualityProductColumns = computed(() => {
            return [
                {
                    title: '产品名称',
                    width: 200,
                    dataIndex: 'productName',
                    key: 'product_name',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品型号',
                    width: 140,
                    dataIndex: 'productModel',
                    key: 'product_model',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '生产人员',
                    width: 140,
                    dataIndex: 'productionPersonnel',
                    key: 'production_personnel',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品颜色',
                    width: 100,
                    dataIndex: 'productColor',
                    key: 'product_color',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '检测总数',
                    width: 120,
                    dataIndex: 'num',
                    key: 'num',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '合格数量',
                    width: 140,
                    dataIndex: 'passNum',
                    key: 'pass_num',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '检测说明',
                    dataIndex: 'qualityExplain',
                    key: 'quality_explain',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
            ]
        })

        //复选框 点击行选中行
        const selectRow = (record) => {
            // const selectedRowKeys = [...cData.selectedRowKeys];
            const selectedRowKeys = [];
            if (selectedRowKeys.indexOf(record.id) >= 0) {
                selectedRowKeys.splice(selectedRowKeys.indexOf(record.id), 1);
            } else {
                selectedRowKeys.push(record.id);
            }
            cData.selectedRowKeys = selectedRowKeys;

            //调用父页面方法
            context.emit('getSelectedRowKeys', selectedRowKeys);
        };
        const rowSelection = computed(() => {
            return {
                selectedRowKeys: cData.selectedRowKeys,
                onChange: (selectedRowKeys) => {
                    cData.selectedRowKeys = selectedRowKeys;

                    //调用父页面方法
                    context.emit('getSelectedRowKeys', selectedRowKeys);
                },
            };
        });
        const customRow = (record) => {
            return {
                onClick: () => {
                    selectRow(record);
                },
            };
        };
        //清除复选勾
        const unSelectedRowKeys = () =>{
            cData.selectedRowKeys = [];
            //调用父页面方法
            context.emit('getSelectedRowKeys', cData.selectedRowKeys);
        }

        //排序事件
        const handleTableChange = (pag, filters, sorter) => {
            // sortedInfo.value = sorter;//将选择的数据传给sortedInfo
            context.emit('setSortedInfo', sorter);
            cData.sort = sorter.columnKey;
            if(sorter.order==="descend"){//当前排序
                cData.desc = "desc";
            }else if(sorter.order==="ascend"){
                cData.desc = "asc";
            }else{
                //重置
                cData.sort = "";
                cData.desc = "";
            }
            queryList(false,cData.queryData);
        };

        //清空排序
        const resetTableChange = ()=>{
            context.emit('setSortedInfo', null);
            // sortedInfo.value = null;
        }

        //翻页
        const pageChange = (current, size) =>{
            dataCurrent.value = current;
            dataPageSize.value = size;
            queryList(false,cData.queryData);
        }

        //修改每页显示的条数
        const onShowSizeChange = (current, pageSize) => {
            dataCurrent.value = current;
            dataPageSize.value = pageSize;

            queryList(false,cData.queryData);
        };

        //统一整理查询的参数 status用于判断是否是重新搜索 true 为新的搜索
        const queryList = (status,list) =>{
            if(status){
                dataCurrent.value = 1;
                dataPageSize.value = props.toPageSize;
                cData.sort = "";
                cData.desc = "";
                resetTableChange();
                unSelectedRowKeys();
            }
            cData.queryData = list;
            let toList = [];
            toList.push(cData.queryData);//将父页的数据放入
            toList.push({
                page:dataCurrent.value,
                limit:dataPageSize.value,
                sort:cData.sort,
                desc:cData.desc,
            });
            context.emit('tData', toList);
        }

        //出入库查看产品详情
        const ioWarehouseSee = (productId)=>{
            context.emit('ioWarehouseSee', productId);
        }

        //订单详情
        const tableOrderDetails = (orderId)=>{
            context.emit('tableOrderDetails', orderId);
        }
        
        //产品详情
        const tableProductDetails = (productId)=>{
            context.emit('tableProductDetails', productId);
        }

        //用户详情
        const tableUserDetails = (userId)=>{
            context.emit('tableUserDetails', userId);
        }

        //提货单详情
        const tableTakeDetails = (takeDeliveryId)=>{
            context.emit('tableTakeDetails', takeDeliveryId);
        }

        //质检单详情
        const tableQualityDetails = (qualityId)=>{
            context.emit('tableQualityDetails', qualityId);
        }

        //发货单详情
        const tableDeliveryDetails= (deliveryId)=>{
            context.emit('tableDeliveryDetails', deliveryId);
        }
        
        //查看excel
        const toExcel = (url) =>{
            //https://view.officeapps.live.com/op/view.aspx?src=
            window.open('https://view.officeapps.live.com/op/embed.aspx?src='+encodeURIComponent(url), '_blank');
        }
        //下载RAR
        const toRAR = (name,url) =>{
            context.emit('toRAR',name, url);
        }

        return {
            dataDefaultPageSize,
            dataPageSizeOptions,
            dataCurrent,
            dataPageSize,
            sortedInfo,

            cData,

            deliveryProductColumns,
            qualityProductColumns,

            selectRow,
            rowSelection,
            customRow,
            unSelectedRowKeys,

            handleTableChange,
            resetTableChange,

            pageChange,
            onShowSizeChange,

            queryList,

            ioWarehouseSee,
            tableOrderDetails,
            tableProductDetails,
            tableUserDetails,
            tableTakeDetails,
            tableQualityDetails,
            tableDeliveryDetails,

            toExcel,
            toRAR,
        }
    }
}
</script>
<style lang='scss' scoped>
.components_table_html{
    width: 100%;
    height: 100%;
    background-color: #fff;
}
.components_table_in{
    width: 100%;
    height: calc(100% - 62px);
}
.components_table_page{
    width: 100%;
    height: 32px;
    margin-top: 15px;
}
.long{
    width: 100%;
    height: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}
.ioWarehouseNumInt{
    color: #f00;
}
.ioWarehouseNumOut{
    color: #0f0;
}
.btn{
    width: calc(100% - 30px);
    height:22px;
    text-align: left;
    padding:0;
}
.take_btn{
    width: calc(100% - 10px);
    height:22px;
    text-align: left;
    padding:0;
}
.imgList{
    float: left;
    width: 32px;
    height: 32px;
    margin-right: 4px;
    overflow: hidden;
    cursor: pointer;
}
.excelName{
    float: left;
    margin-right: 4px;
    overflow: hidden;
    cursor: pointer;
    width: calc(100% - 40px); 
    height: 32px; 
    padding-left: 4px;
    line-height: 32px;
    white-space: nowrap;
    text-overflow: ellipsis;
}
::v-deep .ant-image-img {
    width: auto;
    height: 32px;
}
</style>